import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import * as router from "./modules/baseModules/router.js";
import * as loader from "./modules/baseModules/loader.js";
import * as notification from "./modules/baseModules/notification.js";
import * as form from "./modules/baseModules/form.js";
import * as table from "./modules/baseModules/table.js";
import * as utils from "./modules/baseModules/utils.js";
import * as auth from "./modules/auth.js";
import * as user from "./modules/user.js";
import * as campaign from "./modules/campaign.js";
import * as applicant from "./modules/applicant.js";
import * as recruiter from "./modules/recruiter.js";
import * as customer from "./modules/customer.js";
import * as professional from "./modules/professional.js";
import * as account from "./modules/account.js";
import * as booking from "./modules/booking.js";
import * as wallet from "./modules/wallet.js";
import * as availability from "./modules/availability.js";
import * as messageRequest from "./modules/messageRequest.js";
import * as subscription from "./modules/subscription.js";
import * as messageGroup from "./modules/messageGroup.js";
import * as payOutAccount from "./modules/payOutAccount.js";
import * as notificationMessage from "./modules/notificationMessage.js";
import * as review from "./modules/review.js";
import * as groupSession from "./modules/groupSession.js";
import * as payOut from "./modules/payOut.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    payOut,
    groupSession,
    review,
    notificationMessage,
    payOutAccount,
    messageGroup,
    subscription,
    messageRequest,
    availability,
    wallet,
    booking,
    account,
    campaign,
    user,
    auth,
    router,
    loader,
    notification,
    form,
    table,
    utils,
    applicant,
    recruiter,
    customer,
    professional
  },
  state: {},
  mutations: {},
  actions: {},
  plugins: [createPersistedState()]
});
